/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { Auth } from "aws-amplify";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { APIGateways } from "../../../utility/APIGateways";

const COMPONENT_NAME = "adminCCPServices/contactNotes";

/**
 * This method makes an api call to a lambda via an api gateway secured by cognito pool to
 * save the notes attributes within the given contactId.
 * @param {String} newContactNotes The notes for the contact for in lambda.
 * @param {String} contactId The id for the contact to search cloudwatch events for in lambda.
 */
export const saveNotesData = async (newContactNotes, contactId) => {
	try {
		const token = (await Auth.currentSession()).getIdToken().getJwtToken();
		await axios.post(`${APIGateways.notesEndpoint}/${contactId}`, newContactNotes, {
			headers: {
				Authorization: token,
			},
		});
	} catch (error) {
		v2.error("Error while saving contact notes", {
			additionalData: { error: errorToObject(error), data: { contactId } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SET_CONTACT_NOTES_API_ERROR,
		});

		throw error;
	}
};
